// @mui
import Box from '@mui/material/Box';
import { Stack, Typography } from '@mui/material';

interface Props {
	title: string;
	text?: string;
	color?: string;
	sx?: any;
	symbol?: string;
}

export function Paragraph1(props: Props) {
	return (
		<Box>
			<Typography variant="body2">{props.title}</Typography>
			{props.text && <Typography variant="body2">{props.text}</Typography>}
		</Box>
	);
}

export function Paragraph2(props: Props) {
	return (
		<Box color={props.color || 'inherit'}>
			<Typography variant="boldBody1">{props.title}</Typography>
			{props.text && <Typography variant="body1">{props.text}</Typography>}
		</Box>
	);
}

export function Paragraph3(props: Props) {
	return (
		<Box color={props.color || 'inherit'}>
			<Typography variant="boldBody1">{props.title}</Typography>
			{props.text && (
				<Typography fontFamily="RubikLight" variant="body1">
					{props.text}
				</Typography>
			)}
		</Box>
	);
}

export function Paragraph4(props: Props) {
	//menu item
	return (
		<Box color={props.color || 'inherit'}>
			<Typography variant="body2">{props.title}</Typography>
			{props.text && <Typography variant="caption">{props.text}</Typography>}
		</Box>
	);
}

export function Paragraph5(props: Props) {
	//small title big text
	return (
		<Box sx={props.sx} color={props.color || 'inherit'}>
			<Typography variant="semiCaptionRegular">{props.title}</Typography>
			{props.text && <Typography variant="body1">{props.text}</Typography>}
		</Box>
	);
}

export function Paragraph6(props: Props) {
	//same size 15px with bold header
	return (
		<Stack sx={props.sx} color={props.color || 'inherit'}>
			<Typography variant="boldMedium">{props.title}</Typography>
			{props.text && <Typography variant="body4">{props.text}</Typography>}
		</Stack>
	);
}

export function Paragraph5withBorder(props: Props) {
	//input frame with symbol and small title big text
	return (
		<Stack
			direction="row"
			sx={{
				border: '1px solid #cbdcde',
				borderRadius: '8px',
				height: '54px',
				flexGrow: 1,
				alignItems: 'center',
			}}
		>
			<Typography variant="h3" sx={{ padding: '0 8px' }}>
				{props.symbol}
			</Typography>
			<Paragraph5 title={props.title} text={props.text} />
		</Stack>
	);
}
